import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    id: {
        // field
        label: "ID в Экспедиции",
        inputProps: { name: "id" },
        validators: [requiredField],
        required: true,
    },
    name: {
        // field
        label: "Наименование источника",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    knowledgeBaseUrl: {
        // field
        label: "Ссылка на страницу базы знаний",
        inputProps: { name: "knowledgeBaseUrl" },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
